import React from "react";
import { Link } from "react-router-dom";
import AgreementCheckbox from "../AgreementCheckbox";
import styles from "./readPrivacyPolicyCheckbox.scss";
import { HelpingRoutes, PageRoute } from "../../../../../../../models";

const ReadPrivacyPolicyCheckbox = ({ isChecked, onChange }) => (
  <AgreementCheckbox
    isChecked={isChecked}
    onChange={onChange}
    name="isReadPrivacyPolicy"
  >
    {`${"Pročitao sam"} `}
    <Link
      target="_blank"
      to={`${PageRoute.help}/${HelpingRoutes.privacyPolicy}`}
      className={styles.link}
    >
      {"Pravila o privatnosti"}
    </Link>
  </AgreementCheckbox>
);

export default ReadPrivacyPolicyCheckbox;



// WEBPACK FOOTER //
// ./src/containers/AdDetailsPage/AdDetailsPageMobile/EmailDealerModal/EmailDealerForm/AgreementSection/ReadPrivacyPolicyCheckbox/index.tsx